import React from "react";
import { FaArrowRight, FaEnvelope } from "react-icons/fa";

const gmailComposeUrl =
  "https://mail.google.com/mail/?view=cm&fs=1&to=adamadha3%40gmail.com&su=Portfolio%20enquiry&body=Hello%20Adam%2C%0A%0AI%20came%20across%20your%20portfolio%20and%20would%20like%20to%20discuss%20an%20opportunity.%0A%0ABest%20regards%2C%0A%5BYour%20name%5D";

const Contact = () => (
  <section id="contact" className="section">
    <p className="eyebrow">Contact</p>
    <div className="panel contact-card">
      <div>
        <h2 className="section-title">Let&apos;s build something useful.</h2>
        <p>
          I&apos;m available to contribute to a dynamic team from January 2027.
          If my experience fits your team, I&apos;d be glad to start a
          conversation.
        </p>
      </div>
      <a
        className="button-primary"
        href={gmailComposeUrl}
        target="_blank"
        rel="noreferrer"
      >
        <FaEnvelope /> Email me <FaArrowRight />
      </a>
    </div>
  </section>
);

export default Contact;
